export default __webpack_public_path__ + "img/Inter-Thin_330d40f.woff2";